/**
 * Tiered shipping bar – client-side updates for currency changes
 * and cart updates that don't re-render the section.
 */
(function () {
  function formatBarMoney(cents) {
    if (typeof formatMoney === 'function') {
      return formatMoney(cents);
    }
    var moneyFormat = (typeof theme !== 'undefined' && theme.moneyFormat) || '€{{amount}}';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  }

  function applyPlaceholders(template, vars) {
    return template
      .replace(/\|\|amount\|\|/g, vars.amount)
      .replace(/\|\|items\|\|/g, vars.items)
      .replace(/\|\|item_label\|\|/g, vars.itemLabel)
      .replace(/\|\|tier1_reward\|\|/g, vars.tier1Reward)
      .replace(/\|\|tier2_reward\|\|/g, vars.tier2Reward)
      .replace(/\|\|tier3_reward\|\|/g, vars.tier3Reward)
      .replace(/\|\|shipping_threshold\|\|/g, vars.shippingThreshold);
  }

  function isBundleMode(bar) {
    return bar.dataset.bundleMode === 'true';
  }

  function updateBar(bar) {
    var total = parseInt(bar.dataset.total, 10) || 0;
    var bundleItemCount = parseInt(bar.dataset.bundleItemCount, 10) || 0;
    var bundleMode = isBundleMode(bar);
    var qtyForTiers = bundleMode ? bundleItemCount : 0;
    var tier1Qty = parseInt(bar.dataset.tier1Qty, 10) || 2;
    var tier3Qty = parseInt(bar.dataset.tier3Qty, 10) || 3;
    var tier2Spend = parseInt(bar.dataset.tier2Spend, 10) || 7000;
    var barMax = parseInt(bar.dataset.barMax, 10) || 8400;
    var tier1Marker = parseInt(bar.dataset.tier1Marker, 10) || 6000;
    var itemLabel = bar.dataset.itemLabel || 'bag';
    var tier1Reward = bar.dataset.tier1Reward || '15% extra';
    var tier2Reward = bar.dataset.tier2Reward || 'Free shipping';
    var tier3Reward = bar.dataset.tier3Reward || '20% extra';
    var shippingThreshold = bar.dataset.shippingThreshold || '';

    if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.rate) {
      var rate = parseFloat(Shopify.currency.rate) || 1;
      tier2Spend = Math.round(tier2Spend * rate);
      barMax = Math.round(barMax * rate);
      tier1Marker = Math.round(tier1Marker * rate);
    }

    if (!bundleMode) {
      barMax = tier2Spend;
    }

    var tier1Reached = bundleMode && qtyForTiers >= tier1Qty;
    var tier2Reached = total >= tier2Spend;
    var tier3Reached = bundleMode && qtyForTiers >= tier3Qty;
    var itemsToTier1 = Math.max(tier1Qty - qtyForTiers, 0);
    var itemsToTier3 = Math.max(tier3Qty - qtyForTiers, 0);
    var amountToTier2 = Math.max(tier2Spend - total, 0);
    var progressPct = Math.min((total / barMax) * 100, 100);
    var tier1MarkerPct = Math.min((tier1Marker / barMax) * 100, 100);
    var tier2MarkerPct = Math.min((tier2Spend / barMax) * 100, 100);

    bar.classList.toggle('tiered-shipping-bar--shipping-only', !bundleMode);

    var meta = bar.querySelector('.tiered-shipping-bar__meta');
    if (meta) {
      meta.style.setProperty('--tier1-pos', tier1MarkerPct + '%');
      meta.style.setProperty('--tier2-pos', tier2MarkerPct + '%');
    }

    var fill = bar.querySelector('.tiered-shipping-bar__fill');
    if (fill) {
      if (progressPct > 0) {
        fill.style.width = 'min(calc(' + progressPct + '% + 6px), 100%)';
      } else {
        fill.style.width = '0';
      }
    }

    bar.querySelectorAll('.tiered-shipping-bar__marker--tier1, .tiered-shipping-bar__label--tier1').forEach(function (el) {
      el.classList.toggle('is-reached', tier1Reached);
      if (el.style) el.style.left = tier1MarkerPct + '%';
    });

    bar.querySelectorAll('.tiered-shipping-bar__marker--tier2, .tiered-shipping-bar__label--tier2').forEach(function (el) {
      el.classList.toggle('is-reached', tier2Reached);
      if (bundleMode && el.style) {
        el.style.left = tier2MarkerPct + '%';
        el.style.right = '';
      } else if (el.classList.contains('tiered-shipping-bar__marker--tier2')) {
        el.style.left = 'auto';
        el.style.right = '0';
      }
    });

    bar.querySelectorAll('.tiered-shipping-bar__marker--tier3, .tiered-shipping-bar__label--tier3').forEach(function (el) {
      el.classList.toggle('is-reached', tier3Reached);
    });

    var vars = {
      amount: amountToTier2 > 0 ? formatBarMoney(amountToTier2) : '',
      items: itemsToTier1,
      itemLabel: itemLabel,
      tier1Reward: tier1Reward,
      tier2Reward: tier2Reward,
      tier3Reward: tier3Reward,
      shippingThreshold: shippingThreshold
    };

    var messageEl = bar.querySelector('.tiered-shipping-bar__message-text');
    var messageWrap = bar.querySelector('.tiered-shipping-bar__message');
    if (messageEl) {
      var template;
      var stateClass = 'tiered-shipping-bar--before_tier1';
      var isSuccess = false;

      if (!bundleMode) {
        if (tier2Reached) {
          template = bar.dataset.msgShippingUnlocked;
          stateClass = 'tiered-shipping-bar--shipping_complete';
          isSuccess = true;
        } else {
          template = bar.dataset.msgShippingBefore;
          stateClass = 'tiered-shipping-bar--shipping_only';
        }
      } else if (tier3Reached && tier2Reached && tier1Reached) {
        template = bar.dataset.msgComplete;
        stateClass = 'tiered-shipping-bar--complete';
        isSuccess = true;
      } else if (tier2Reached && tier1Reached) {
        template = bar.dataset.msgTier2;
        vars.items = itemsToTier3;
        stateClass = 'tiered-shipping-bar--tier2';
      } else if (tier1Reached) {
        template = bar.dataset.msgTier1;
        stateClass = 'tiered-shipping-bar--tier1';
      } else {
        template = bar.dataset.msgBefore;
        vars.items = itemsToTier1;
      }

      bar.className = bar.className
        .replace(/tiered-shipping-bar--\S+/g, '')
        .trim() + ' ' + stateClass + (bundleMode ? '' : ' tiered-shipping-bar--shipping-only');
      messageEl.innerHTML = applyPlaceholders(template, vars);
      if (messageWrap) {
        messageWrap.classList.toggle('tiered-shipping-bar__message--success', isSuccess);
      }
    }
  }

  function initAll() {
    document.querySelectorAll('.tiered-shipping-bar').forEach(updateBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(initAll, 100);
    });
  }

  document.addEventListener('shopify:section:load', initAll);
})();
